import * as React from 'react';
import S from 's-js';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';

interface PCDismissibleProps {
    onDismiss : () => void;
    dismissibleWhen? : () => boolean;
    className? : string;
    children? : any;
}

export class PCDismissible extends SuperCriticalComponent<PCDismissibleProps> {
    ref : (e : HTMLDivElement | null) => void;
    propagationStopped = false;

    constructor(props : PCDismissibleProps) {
        super(props);
        this.ref = SuperCriticalReference(this, (props : PCDismissibleProps, el : HTMLDivElement) => {
            let dismissibleWhen = props.dismissibleWhen || (() => true);
            if (dismissibleWhen()) {
                let onDocumentClick = () => {
                    let propagationStopped = this.propagationStopped;
                    this.propagationStopped = false;
                    if (!propagationStopped) props.onDismiss();
                };

                let onDivClick = () => {
                    // TH: We've gotta be careful here b/c React delegates its events to the document.
                    // A couple things that won't work:
                    // 
                    // -- Instead of setting a propagationStopped flag we could've just called e.stopPropagation().
                    //    But that's bad b/c it means the click event never reaches the document, which is where React's
                    //    onClick handlers are waiting to catch it. So React onClick handlers inside the dismissible element never fire.
                    // 
                    // -- Instead of adding a native click event to the div element, we could've added a React onClick handler in our
                    //    srender method below. That would work, but it would have the counterintuitive effect that any React onClick handlers
                    //    inside the dismissible element can't call React's stopPropagation method, otherwise our handler will never fire to set the
                    //    propagationStopped flag, and the document dismiss handler WILL fire.
                    // 
                    // This is all b/c React's stopPropagation method can't stop propagation to native click handlers.
                    // See http://stackoverflow.com/a/24421834
                    this.propagationStopped = true;
                };

                document.addEventListener('click', onDocumentClick);
                el.addEventListener('click', onDivClick);

                S.cleanup(() => {
                    this.propagationStopped = false;
                    document.removeEventListener('click', onDocumentClick);
                    el.removeEventListener('click', onDivClick);
                });
            }
        });
    }

    srender(props : PCDismissibleProps) {
        return (
            <div className={'pc-dismissible ' + (props.className ? props.className : '')}
                ref={this.ref}>
                {props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/pcdismissible/view.tsx